/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const HamburgerInactiveIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 15H20" stroke="currentColor" strokeWidth="1.5"></path>
      <path d="M4 9H20" stroke="currentColor" strokeWidth="1.5"></path>
    </Icon>
  );
};
